export default class Group {
    id: number;
    groupName: string;
    creationTime: Date;
    lastModificationTime?: Date
    crossBorderSite: string;
    crossBorderSites: number[];
    nativeSite: string;
    nativeSites: number[];
    abroadWarehouse: string;
    abroadWarehouses: number[];
    groupPersonnel: string;
    groupPersonnels: number[];
    tenantId: number;
    isOk: number;
}